import React from "react";
import { ToastContainer } from "react-toastify";
import Header from "./Header";

const Layout = ({ children, title }) => {
  return (
    <div className="m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl">
      <ToastContainer />
      <Header category="Page" title={title} />

      <div className="w-full">{children}</div>
    </div>
  );
};

export default Layout;
